

















import { Component, Prop, Mixins } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

import { availableCountries, getAvailableCountryDataByCode } from '@/helpers/countries'
import { Country } from '@/interfaces/Countries'
import { dictionary } from '@/helpers/dictionnary'
import Errors from '@/mixins/Errors'

@Component
export default class LanguageDropdown extends Mixins(Errors) {
  countries: Country[] = availableCountries
  currentCountry: Country = null
  isLoading = false

  @Getter('locale', { namespace: 'user' }) locale
  @Action('updateUserLocal', { namespace: 'user' }) updateUserLocal

  created() {
    this.currentCountry = getAvailableCountryDataByCode(this.locale)
  }

  async updateLocale(code) {
    try {
      this.isLoading = true
      await this.updateUserLocal(code)
      this.$validator.localize(code, dictionary[code])
      this.currentCountry = getAvailableCountryDataByCode(code)
    } catch (error) {
      this.displayErrors(error)
    } finally {
      this.isLoading = false
    }
  }
}
